import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserMenu from './UserMenu.jsx';
import { useJobStatus } from '../contexts/JobStatusContext.jsx';

function Topbar({ currentUser, logout }) {
  const [darkMode, setDarkMode] = useState(
    localStorage.getItem('darkMode') === 'true' ||
    window.matchMedia('(prefers-color-scheme: dark)').matches
  );
  const [isIframe, setIsIframe] = useState(false);
  const [isTabsMenuOpen, setIsTabsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { toggleDrawer, activeJobCount } = useJobStatus();

  useEffect(() => {
    // Detect if we're in an iframe
    setIsIframe(window !== window.parent);

    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  // If we're in an iframe, do not show
  if (isIframe)
    return null;

  // Normal render outside iframe
  return (
    <div className="bg-white dark:bg-gray-800 shadow-md">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <a
          href="/"
          className="flex items-center space-x-3 text-xl font-bold text-gray-800 dark:text-white cursor-pointer no-underline"
          onClick={(e) => {
            // Only intercept regular clicks (no modifier keys)
            // Let browser handle: Ctrl/Cmd+click, Shift+click, right-click, middle-click
            if (!e.ctrlKey && !e.metaKey && !e.shiftKey) {
              e.preventDefault();
              navigate('/');
            }
          }}
        >
          <img
            src="/logo/favicon-512.png"
            alt="Sellout Processor"
            className="h-9 w-9 rounded object-contain mr-1"
          />
          Globe Processor
        </a>

        {/* Right side: User menu */}
        <div className="flex items-center space-x-4">
          <button
            onClick={toggleDrawer}
            className="relative px-4 py-2 rounded-md border border-gray-200 dark:border-gray-700 text-sm font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800 transition"
          >
            Jobs
            {activeJobCount > 0 && (
              <span className="ml-2 inline-flex items-center justify-center rounded-full bg-blue-600 text-white text-xs font-semibold px-2 py-0.5">
                {activeJobCount}
              </span>
            )}
          </button>
          <UserMenu
            currentUser={currentUser}
            logout={logout}
            darkMode={darkMode}
            toggleDarkMode={toggleDarkMode}
          />
        </div>
      </div>
    </div>
  );
}

export default Topbar;
